/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadScreenerLeadInfoRace
 */
export interface PalAuthSubmissionLeadScreenerLeadInfoRace {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadScreenerLeadInfoRace
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadScreenerLeadInfoRace
     */
    name?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadScreenerLeadInfoRace interface.
 */
export function instanceOfPalAuthSubmissionLeadScreenerLeadInfoRace(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSON(json: any): PalAuthSubmissionLeadScreenerLeadInfoRace {
    return PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadScreenerLeadInfoRace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PalAuthSubmissionLeadScreenerLeadInfoRaceToJSON(value?: PalAuthSubmissionLeadScreenerLeadInfoRace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

